import { environment } from '@env/environment';

export const truncateArray = (array, key): any[] => {
  let returnObject: any[];

  const mappedArray = array.map(item => {
    return {
      name: `${item[key]}`
    }
  });

  const [firstItem, secondItem, ...rest] = mappedArray;
  if (firstItem) {
    returnObject = [firstItem];
  }

  if (secondItem) {
    returnObject.push(secondItem);
  }

  if (rest && rest.length) {
    returnObject.push({
      name: `${rest.length} More...`,
      tooltip: rest.map(item => item.name).join('<br>')
    });
  }

  return returnObject;
};

export const truncateRepositories = (array): any[] => {
  let returnObject: any[];

  const [firstItem, ...rest] = array;

  if (firstItem) {
    returnObject = [firstItem];
  }

  const tooltipRowCreator = (item) => {
    return item.repositoryLink
      ? `<a href="${item.repositoryLink}" target="_blank" class="count__header__link">
          ${item.repository}
         </a>`
      : `<span class="count__header__link">${item.repository}</span>`;
  };

  if (rest && rest.length) {
    returnObject.push({
      repository: `${rest.length} More...`,
      tooltip: `<strong>Repositories</strong><br>` + rest.map(tooltipRowCreator).join('<br>')
    });
  }

  return returnObject;
};

export const truncateTeams = (array): Developer.TeamTagModel[] => {
  let returnObject: any[];

  const [firstItem, secondItem, ...rest] = array;

  if (firstItem) {
    returnObject = [firstItem];
  }

  if (secondItem) {
    returnObject.push(secondItem);
  }

  const tooltipRowCreator = (item) => {
    return item.scorecardId
      ? `<a href="/scorecard/team/${item.id}" target="_blank" class="count__header__link">
           ${item.name}
         </a>`
      : `<span class="count__header__link">${item.name}</span>`;
  };

  if (rest && rest.length) {
    returnObject.push({
      name: `${rest.length} More...`,
      tooltip: rest.map(tooltipRowCreator).join('<br>')
    });
  }
  return returnObject;
};

export const truncateFooter = (array): any[] => {
  let returnObject: any[];

  const [firstItem, secondItem, ...rest] = array;

  if (firstItem) {
    returnObject = [firstItem];
  }

  if (secondItem) {
    returnObject.push(secondItem);
  }

  const tooltipRowCreator = (item) => {
    return item.url
      ? `<a class="count__header__link" href="${item.url}" target="_blank">
            <span style="padding: 0 5px 0 3px;"> ${item.text} </span>
         </a>`
      : `<span>
            <span style="padding: 0 5px 0 3px;" class="count__header__link"> ${item.text} </span>
         </span>`;
  };

  if (rest && rest.length) {
    returnObject.push({
      text: `${rest.length} More...`,
      tooltip: rest.map(item => tooltipRowCreator(item)).join('<br>')
    });
  }

  return returnObject;
};

export const fullNamePropertyCreator = (obj): any => {
  if (obj.fullName) {
    return obj;
  }
  obj.fullName = fullNameManufacturer(obj);
  return obj;
};

export const fullNameManufacturer = (obj): string => {
  return obj.name && obj.surname
    ? `${obj.name} ${obj.surname}`
    : (obj.name ? obj.name : obj.username || obj.userName);
};

export const backgroundImageCreator = (obj): any => {
  obj.backgroundImage = obj.avatar ? `url(${createImageUrl(obj.avatar)})` : null;
  return obj;
};

export const avatarCreator = (obj): any => {
  obj.avatar = obj.avatar ? `url(${obj.avatar})` : null;
  return obj;
};

export const createImageUrl = (path: string) =>
  path.startsWith('http') || path.includes('api/') ? path : `${environment.imageBaseUrl}${path}`;

export function mapToObject<K extends string, V>(
  pairs: Iterable<[K, V]>
): Record<K, V> {
  return Array.from(pairs).reduce<Record<K, V>>((acc, [key, value]) => {
    acc[key] = value;
    return acc;
    // tslint:disable-next-line:no-object-literal-type-assertion
  }, {} as Record<K, V>);
}
